export default __webpack_public_path__ + "32e56e6.png";